  
import {ReactElement} from 'react';

  
import {Container, SxProps} from '@mui/material';

interface Props {
  children: ReactElement | ReactElement[];
  bgColor: string;
  sx?: SxProps;
  selfRef?: (node: HTMLDivElement | null) => void;
  topPosition?: number;
}

export const PageSection = ({children, bgColor, sx, selfRef, topPosition}: Props) => {
  return (
    <Container
      ref={selfRef}
      maxWidth={false}
      sx={{
        backgroundColor: bgColor,
        width: '100%',
        position: 'absolute',
        left: 0,
        ...(topPosition && {top: topPosition}),
        clear: 'both',
        ...sx,
      }}
    >
      <Container maxWidth={false} sx={{padding: 0, maxWidth: '1200px'}}>
        {children}
      </Container>
    </Container>
  );
};
